import throttle from 'lodash/throttle'
import { useEffect, useRef, useState } from 'react'

// https://stackoverflow.com/a/61719846/14073509

/**
 * Check if an element is in viewport

 * @param {number} offset - Number of pixels up to the observable element from the top. Default: 0
 * @param {number} throttleMilliseconds - Throttle observable listener in ms. Default: 100
 * @param {number} initialRefValue - initial value for useRef. Default: null
 */

export default function useVisibility(
  initialRefValue: HTMLDivElement | null = null,
  offset = 0,
  throttleMilliseconds = 100,
): [boolean, React.MutableRefObject<HTMLDivElement | null>] {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const currentElement = useRef(initialRefValue)

  const onScroll = throttle(() => {
    if (!currentElement.current) {
      setIsVisible(false)
      return
    }
    const top = currentElement.current.getBoundingClientRect().top
    setIsVisible(top + offset >= 0 && ((top - offset <= window.innerHeight) as boolean))
  }, throttleMilliseconds)

  useEffect(() => {
    document.addEventListener('scroll', onScroll, true)
    return () => document.removeEventListener('scroll', onScroll, true)
  })

  return [isVisible, currentElement]
}
